import { render } from "./ExchangeResult.vue?vue&type=template&id=38613658&scoped=true&ts=true"
import script from "./ExchangeResult.vue?vue&type=script&lang=ts"
export * from "./ExchangeResult.vue?vue&type=script&lang=ts"

import "./ExchangeResult.vue?vue&type=style&index=0&id=38613658&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38613658"]])

export default __exports__